import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const MonthGrid = forwardRef(function MonthGrid(
  {
    children,
    editCalendar = false,
    startDay = 0,
    columnWidths = null,
    sectionMinWidth = null,
  },
  ref
) {
  const { t } = useTranslation("dashboard");
  const dayKeys = editCalendar
    ? [
        "calendar.monthGrid.sunday",
        "calendar.monthGrid.monday",
        "calendar.monthGrid.tuesday",
        "calendar.monthGrid.wednesday",
        "calendar.monthGrid.thursday",
        "calendar.monthGrid.friday",
        "calendar.monthGrid.saturday",
      ]
    : [
        "calendar.monthGrid.sun",
        "calendar.monthGrid.mon",
        "calendar.monthGrid.tues",
        "calendar.monthGrid.wed",
        "calendar.monthGrid.thurs",
        "calendar.monthGrid.fri",
        "calendar.monthGrid.sat",
      ];
  const days = dayKeys.map((key) => t(key));
  const finalDay = [
    ...days.slice(startDay || 0),
    ...days.slice(0, startDay || 0),
  ];

  // Build dynamic grid template if columnWidths are provided
  let gridStyle = {};
  if (columnWidths) {
    // columnWidths can be either numbers (which need 'fr' suffix) or strings (like 'minmax(...)')
    const columnsTemplate = columnWidths
      .map((w) => (typeof w === "number" ? `${w}fr` : w))
      .join(" ");
    gridStyle = {
      gridTemplateColumns: editCalendar
        ? `32px ${columnsTemplate}`
        : columnsTemplate,
    };
  }

  // Build dynamic min-width for section if provided
  let sectionStyle = {};
  if (sectionMinWidth) {
    sectionStyle = { minWidth: sectionMinWidth };
  }

  return (
    <div ref={ref} className="calendar-month-wrapper">
      <section
        className={`Calendar-Month${editCalendar ? " edit-modex" : ""}`}
        style={sectionStyle}
      >
        <article style={gridStyle}>
          {editCalendar ? <div className="invisible" /> : null}
          {finalDay.map((day) => (
            <p key={day} className="s2">
              {day}
            </p>
          ))}
        </article>
        {children}
      </section>
    </div>
  );
});

export default MonthGrid;
